






























import { Vue, Component, Prop } from 'vue-property-decorator';
import type { SigningTheme } from '../../signing-theme/types/theme';
import { BrandingHelper } from '../../signing-theme/helpers/branding.helper';
import { BrowserHelper } from '../helpers/browser.helper';

@Component
export default class ChatFab extends Vue {
  @Prop() open!: boolean;
  @Prop() newCommentsCount!: number;
  @Prop() theme?: SigningTheme;
  @Prop({ default: false }) isDsr: boolean;

  observer: IntersectionObserver;

  public handleClick(): void {
    this.$emit('click');
  }

  get hasNewComments(): boolean {
    return this.newCommentsCount > 0;
  }

  public get isBrowserIE(): boolean {
    return BrowserHelper.isIE(navigator);
  }

  get hasTheme(): boolean {
    return !!this.theme && !!this.theme.accentColor;
  }

  get chatFabStyle() {
    if (this.hasTheme) {
      return {
        '--chat-background-color': BrandingHelper.getBackgroundColor(
          this.theme.accentColor,
          false,
          false
        ),
        '--chat-background-color-hover': BrandingHelper.getBackgroundColorHover(
          this.theme.accentColor,
          false,
          false
        ),
        '--icon-color': BrandingHelper.getTextColor(this.theme.accentColor, false, false),
      };
    }
    return {};
  }

  async mounted() {
    if (!this.isDsr) {
      return;
    }

    await this.$nextTick();
    const navigationButtons = document.querySelector('div.navigation-buttons') as HTMLDivElement;
    if (!navigationButtons) {
      return;
    }

    const chatFab = this.$refs.chatFab as HTMLButtonElement;

    this.observer = new IntersectionObserver(
      entries => {
        const [{ isIntersecting }] = entries;
        if (isIntersecting) {
          chatFab.classList.add('add-margin');
        }

        if (!isIntersecting) {
          chatFab.classList.remove('add-margin');
        }
      },
      {
        threshold: 0.1,
      }
    );

    this.observer.observe(navigationButtons);
  }

  beforeDestroy() {
    if (!this.isDsr) {
      return;
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
